import type { VoidFunctionComponent } from 'react';

import type { FossabotNoFixType } from './useFossabotNoFix';

import styles from './FossabotNoFixBox.module.less';

/*
 * Copy is kept identical to the legacy Remediation card's unfixable panels
 * (shared/vulns/RemediationPanels/RemediationSuggestion), which this panel
 * replaces unless the disableFossabotAutoPRs flag is on.
 */
const NO_FIX_COPY: Record<FossabotNoFixType, { heading: string; description: string }> = {
  'no-fix': {
    heading: 'No fix available',
    description: 'FOSSA cannot find a fix for this vulnerability at this time.',
  },
  'unable-to-calculate': {
    heading: 'Unable to calculate',
    description: 'FOSSA cannot calculate a fix for this vulnerability.',
  },
};

type Props = {
  type: FossabotNoFixType;
};

/**
 * Shown in the Remediation panel below the connection banner when the
 * vulnerability has neither a partial nor a complete fix, in place of the
 * upgrade options (not connected) or the fossabot fix card (connected).
 */
export const FossabotNoFixBox: VoidFunctionComponent<Props> = ({ type }) => {
  const { heading, description } = NO_FIX_COPY[type];

  return (
    <div className={styles.box} data-testid="fossabot-no-fix-box">
      <span className={styles.heading}>{heading}</span>
      <p className={styles.description}>{description}</p>
    </div>
  );
};
